import Services from '@/components/modules/place/Services';
import { hasFeatureSetting, isMobile, isServiceBookable, startOfDay } from '@/helpers';
import { __ } from '@/locale';
import { Place, PlaceCampaign, PlaceService } from '@/types/state/shared';

const getBookableServicesWithCampaign = (campaign: PlaceCampaign, place: Place) => {
  if (!(place?.services && campaign?.services?.length > 0)) {
    return null;
  }

  const services: PlaceService = {};
  const categories = place.services;

  campaign.services.forEach((campaignService) => {
    const matchingService = categories
      .flatMap((category) => category.services)
      .find((item) => item.id === campaignService.id && isServiceBookable(item, place));

    if (matchingService) {
      services[matchingService.id] = matchingService;
    }
  });

  return campaign.type === 6 || Object.keys(services).length === campaign.services.length ? services : null;
};

const Categories = ({
  place,
  onClickReadMore,
}: {
  place: Place;
  onClickReadMore: (title: string, text: string, id: number) => void;
}) => {
  const hasCollapsedSetting = hasFeatureSetting(place, 'collapsed_services');
  const services = place.services;

  const getCampaignServices = () => {
    const date = startOfDay();
    const campaignServicesList = [];
    for (let i = 0; i < place.campaigns.length; i++) {
      const campaign = place.campaigns[i];
      const campaignServices = getBookableServicesWithCampaign(campaign, place);

      if (!campaignServices) continue;

      const campaignServicesIds = Object.keys(campaignServices);

      // add campaign if the campaign is valid for the selected date
      if (date >= campaign.startDate * 1000 && date <= campaign.endDate * 1000) {
        // show only discount campaigns for now
        if (campaign.type === 6) {
          campaignServicesIds.forEach((id) => {
            campaignServicesList.push(campaignServices[id]);
          });
        }
      }
    }
    return campaignServicesList;
  };

  const campaignServices = getCampaignServices();

  return (
    <>
      {campaignServices.length > 0 && (
        <Services
          place={place}
          categoryName={__('Kampanjer')}
          services={campaignServices}
          handleClickReadMore={onClickReadMore}
          key={0}
          _expanded={!hasCollapsedSetting}
        />
      )}
      {services
        .filter((category) => category.services.length > 0)
        .map((category, index) => {
          let isOpen = isMobile() ? false : true;
          if (services.length === 1) {
            isOpen = true;
          }
          const categoryName = category ? (category.own === true ? category.name : __(category.name)) : '';
          return (
            <Services
              place={place}
              categoryName={categoryName}
              services={category.services}
              handleClickReadMore={onClickReadMore}
              key={index + 1}
              _expanded={!hasCollapsedSetting && (index === 0 || isOpen)}
            />
          );
        })}
    </>
  );
};

export default Categories;
